var React = require('react');

function IconCheck (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"none","strokeWidth":"1"},React.createElement("g",{"fill":"#142B6F","fillRule":"nonzero","transform":"translate(-337.000000, -655.000000)"},React.createElement("g",{"transform":"translate(135.000000, 530.000000)"},React.createElement("g",{"transform":"translate(0.000000, 118.000000)"},React.createElement("g",{"transform":"translate(202.000000, 7.000000)"},React.createElement("path",{"d":"M4.26628075,9.733733 C4.12735166,9.87894203 3.93053546,10 3.7568741,10 C3.58321274,10 3.38639653,9.87294964 3.24167873,9.72761953 L0,6.33805692 L1.57391592,4.73306798 L3.76266281,6.98950512 L10.4796345,0 L12,1.60469028 L4.26628075,9.733733 Z"})))))));
}

IconCheck.defaultProps = {"width":"12","height":"10","version":"1.1","viewBox":"0 0 12 10"};

module.exports = IconCheck;

IconCheck.default = IconCheck;
